import { SelectOption } from '@/components/elements/select'

export const formatSupplemntMap: SelectOption[] = [
	{ label: 'Polvo', value: 'Polvo' },
	{ label: 'Líquido', value: 'Líquido' },
	{ label: 'Cápsulas', value: 'Cápsulas' },
	{ label: 'Tabletas', value: 'Tabletas' },
	{ label: 'Softgels', value: 'Softgels' },
	{ label: 'Gomitas', value: 'Gomitas' },
	{ label: 'Barra', value: 'Barra' },
	{ label: 'Gel', value: 'Gel' },
	{ label: 'Ampolla', value: 'Ampolla' },
	{ label: 'Sobre', value: 'Sobre' },
	{ label: 'Otro', value: 'Otro' },
]